<template>
    <Select
        v-model="model"
        :items="items"
        item-key="parameter_id"
        :searchable="true"
        :search-keys="['name']"
        :placeholder="translate('bracket_category_select.select_category')"
        :search-placeholder="translate('bracket_category_select.search_category')"
        :no-results-text="translate('bracket_category_select.no_categories_found')"
        :aria-label="translate('bracket_category_select.select_category')"
        :dropdown-mode="dropdownMode"
    >
        <template v-slot:selected-item="{ selectedItem }">
            <BracketCategoryOption v-if="selectedItem" :bracket="selectedItem" />
        </template>

        <template v-slot:item="{ item }">
            <BracketCategoryOption :bracket="item" />
        </template>

        <template v-slot:no-results>
            <span class="icon" aria-hidden="true">
                <i class="fas fa-exclamation-triangle"></i>
            </span>
            <span>{{ translate("bracket_category_select.no_categories_found") }}</span>
        </template>
    </Select>
</template>

<script setup lang="ts">
    import Select from "../Common/Select.vue";
    import BracketCategoryOption from "./BracketCategoryOption.vue";
    import { translate } from "../Common/translations";
    import { ComplexBracket } from "../Common/Brackets/types";

    const model = defineModel<number | null>();

    defineProps<{
        items: ComplexBracket[];
        dropdownMode?: "absolute" | "container";
    }>();
</script>

<style scoped>
    /* Events can have hundreds of categories, so give the list more room than the default Select height. */
    @media screen and (min-width: 769px) {
        :deep(.select-dropdown-content) {
            max-height: min(60vh, 480px);
        }
    }

    /* Let the selected category fill the trigger, so the count is right-aligned like in the list. */
    :deep(.select-selected-item) {
        flex-grow: 1;
        min-width: 0;
    }
</style>
